import api from './api'

export default {
  list(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/manual-castrations', { params })
  },
  create(body) {
    return api.post('/partner-licensings/:partnerLicensingId/manual-castrations', body)
  },
  show(id) {
    return api.get(`/partner-licensings/:partnerLicensingId/manual-castrations/${id}`)
  },
  destroy(id) {
    return api.delete(`/partner-licensings/:partnerLicensingId/manual-castrations/${id}`)
  },
}
